import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const ThreePeople = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 63 44"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Dashboard" fill="none" fillRule="evenodd">
      <g
        transform="translate(-129 -865)"
        fill={fillColor}
        fillRule="nonzero"
        stroke={fillColor}
      >
        <g transform="translate(129 867)">
          <path
            d="M31.3837835,15.5826332 C35.605174,15.5826332 39.0878212,12.095758 39.0878212,7.86924261 C39.0878212,3.64272721 35.7107088,0.155851996 31.3837835,0.155851996 C27.0568583,0.155851996 23.6797459,3.64272721 23.6797459,7.86924261 C23.6797459,12.095758 27.162393,15.5826332 31.3837835,15.5826332 Z"
            strokeWidth="4.32"
          />
          <path
            d="M29.9,20.8784531 C24.3303487,20.8784531 19.8152542,25.3935475 19.8152542,30.9631988 L19.8152542,37.6431988 C19.8152542,39.523588 21.3396108,41.0479446 23.22,41.0479446 L39.7997647,41.0479446 C41.6801539,41.0479446 43.2045105,39.523588 43.2045105,37.6431988 L43.2045105,30.9631988 C43.2045105,25.3935475 38.689416,20.8784531 33.1197647,20.8784531 L29.9,20.8784531 Z"
            strokeWidth="1.831"
          />
          <path
            d="M54.1972235,24.7493972 C51.3789256,24.7493972 49.0465412,22.3419484 49.0465412,19.4329478 C49.0465412,16.5239472 51.3789256,14.1164984 54.1972235,14.1164984 C57.0155214,14.1164984 59.3479059,16.5239472 59.3479059,19.4329478 C59.3479059,22.3419484 57.0155214,24.7493972 54.1972235,24.7493972 Z"
            strokeWidth="2.88"
          />
          <path
            d="M52.9774468,28.4591489 C49.5657371,28.4591489 46.8,31.2248861 46.8,34.6365957 L46.8,38.8340426 C46.8,39.9275664 47.6864762,40.8140426 48.78,40.8140426 L59.82,40.8140426 C60.9135238,40.8140426 61.8,39.9275664 61.8,38.8340426 L61.8,34.6365957 C61.8,31.2248861 59.0342629,28.4591489 55.6225532,28.4591489 L52.9774468,28.4591489 Z"
            strokeWidth="1.8"
          />
          <path
            d="M8.29722353,24.7493972 C5.47892564,24.7493972 3.14654118,22.3419484 3.14654118,19.4329478 C3.14654118,16.5239472 5.47892564,14.1164984 8.29722353,14.1164984 C11.1155214,14.1164984 13.4479059,16.5239472 13.4479059,19.4329478 C13.4479059,22.3419484 11.1155214,24.7493972 8.29722353,24.7493972 Z"
            strokeWidth="2.88"
          />
          <path
            d="M7.07744681,28.4591489 C3.66573714,28.4591489 0.9,31.2248861 0.9,34.6365957 L0.9,38.8340426 C0.9,39.9275664 1.7864762,40.8140426 2.88,40.8140426 L13.92,40.8140426 C15.0135238,40.8140426 15.9,39.9275664 15.9,38.8340426 L15.9,34.6365957 C15.9,31.2248861 13.1342629,28.4591489 9.72255319,28.4591489 L7.07744681,28.4591489 Z"
            strokeWidth="1.8"
          />
        </g>
      </g>
    </g>
  </svg>
);

ThreePeople.defaultProps = defaultProps;

export { ThreePeople };
